import React from 'react';
import { styled, Caption, Title, SubTitle } from '@teko/ds-desktop';
import { formatCurrency } from '../../helpers/number.es.js';

const isShowRetailPrice = (supplierRetailPrice, latestPrice) => {
  let newSupplierRetailPrice = supplierRetailPrice;
  let newLatestPrice = latestPrice;
  if (typeof supplierRetailPrice === "string") {
    newSupplierRetailPrice = supplierRetailPrice.replace(/[₫đ.]/g, "");
  }
  if (typeof latestPrice === "string") {
    newLatestPrice = latestPrice.replace(/[₫đ.]/g, "");
  }
  return Number(newSupplierRetailPrice) > Number(newLatestPrice);
};
const ProductPrice = ({
  supplierRetailPrice,
  latestPrice,
  discountPercent,
  textColor = "primary500",
  align = "start",
  size = "m",
  className,
  priceRange
}) => {
  const formattedRetailPrice = typeof supplierRetailPrice === "number" ? formatCurrency(supplierRetailPrice) : supplierRetailPrice;
  const formattedLatestPrice = typeof latestPrice === "number" ? formatCurrency(latestPrice) : latestPrice;
  let renderedRetailPrice, renderedDiscount;
  const renderedLatestPrice = () => {
    if (!priceRange) {
      return size === "l" ? /* @__PURE__ */ React.createElement(Title, {
        className: "att-product-detail-latest-price",
        level: 2,
        color: textColor,
        weight: "bold"
      }, formattedLatestPrice) : /* @__PURE__ */ React.createElement(SubTitle, {
        className: "att-product-detail-latest-price",
        level: 1,
        color: textColor
      }, formattedLatestPrice);
    }
    const formattedMinPrice = formatCurrency(priceRange.min, false);
    const formattedMaxPrice = formatCurrency(priceRange.max);
    return size === "l" ? /* @__PURE__ */ React.createElement(StyledTitle, {
      level: 2,
      color: textColor,
      weight: "bold",
      line: 1
    }, formattedMinPrice, " - ", formattedMaxPrice) : /* @__PURE__ */ React.createElement(StyledSubTitle, {
      level: 1,
      color: textColor,
      line: 1
    }, formattedMinPrice, " - ", formattedMaxPrice);
  };
  switch (size) {
    case "l":
      renderedRetailPrice = /* @__PURE__ */ React.createElement(StyledRetailPrice, {
        className: "att-product-detail-retail-price",
        level: 1,
        color: "textSecondary"
      }, formattedRetailPrice);
      renderedDiscount = /* @__PURE__ */ React.createElement(Caption, {
        level: 1,
        color: textColor
      }, discountPercent);
      break;
    default:
      renderedRetailPrice = /* @__PURE__ */ React.createElement(StyledRetailPrice, {
        className: "att-product-detail-retail-price",
        level: 1,
        color: "textSecondary"
      }, formattedRetailPrice);
      renderedDiscount = /* @__PURE__ */ React.createElement(Caption, {
        level: 1,
        color: textColor
      }, discountPercent);
      break;
  }
  const showRetailPrice = supplierRetailPrice && isShowRetailPrice(supplierRetailPrice, latestPrice);
  const isShowDiscount = !!discountPercent;
  return /* @__PURE__ */ React.createElement(ProductPriceWrapper, {
    align,
    className
  }, renderedLatestPrice(), (showRetailPrice || isShowDiscount) && /* @__PURE__ */ React.createElement(StyledDiscount, null, showRetailPrice && renderedRetailPrice, isShowDiscount && renderedDiscount));
};
const ProductPriceWrapper = styled.div(({ align }) => `
  display: flex;
  flex-direction: column;
  align-items: ${align};
  height: 2.5rem;
`);
const StyledRetailPrice = styled(Caption)(({ theme }) => `
    text-decoration: line-through;
    margin-right: ${theme == null ? void 0 : theme.spacing.s4};
`);
const StyledDiscount = styled.div`
  display: flex;
  height: 1rem;
`;
const StyledTitle = styled(Title)`
  word-break: break-all;
`;
const StyledSubTitle = styled(SubTitle)`
  word-break: break-all;
`;

export { ProductPrice };
